<template>
    <div class="contact-box">
        <!-- <Test></Test> -->
        <ChildBanner :childbannerData='childbannerData' ref='childBaner' class="white"></ChildBanner>
        <DoBetter :childModle='childModleData' class="black"></DoBetter>
        <Company class="black"></Company>
        <Recruit class="white"></Recruit>
    </div>
</template>
<script>
    import ChildBanner from '@/components/base/childbanner'//引入子页面的banner
    import DoBetter from '@/components/main/contact/dobetter'//引入页面说明    
    import Company from '@/components/main/contact/company'//引入公司信息
    import Recruit from '@/components/main/contact/recruit'//引入招聘信息
    export default {
        name: 'Contact',
        data() {
            return {
                childbannerData: {
                    childbanner: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/contcatus/%E7%BB%84%20754.jpg',
                    caption: 'CONTACT US',
                    title: '联系我们'
                },
                childModleData: {
                    caption: 'Do Better.',
                    center: '关于视频号: BIG超聊海外营销<br/>视频号简介：在这里，读懂外贸。一起探讨海外数字营销技巧，用技术武装自己，分享Google SEO 知识、营销工具教程、市场数据、行业洞察及线上直播、线下会议等活动资讯。我们让外贸生意更加简单有效，实现客户池的持续增长！很荣幸，感谢您的关注！',
                    topath: {
                        name: '关于我们 >',
                        url: '/about'
                    }
                }
            }
        },
        components: {
            ChildBanner,
            DoBetter,
            Company,
            Recruit,
        },
        methods: {
            childMethods() {
                this.$refs.childBaner.changeShow()
            }
        }
    }
</script>
<style scoped>
    .DoBetter>>>.center-caption {
        bottom: 0;
        right: 0;
        transform: translateY(-70%);
    }

    .DoBetter>>>.center-box::after {
        background: transparent url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/contcatus/_DSC0315.jpg') no-repeat center center;
        background-size: cover;
    }

    .DoBetter>>>.center-caption {
        text-transform: none;
        font-weight: gilroybold4;
    }

    @media(max-width: 1028px) {
        .DoBetter>>>.center-caption {
            bottom: 0;
            right: 0;
            transform: translateY(-112%);
        }
    }

    @media(max-width: 995px) {
        .DoBetter>>>.center-box::after {
            display: none;
        }

        .DoBetter>>>.center-caption {
            bottom: 100%;
            right: 0;
            transform: translateY(100%);
        }

        .contact-box>>>.DoBetter {
            padding-bottom: 50px;
        }
        .DoBetter>>>.mobile-img{
            display: block;
            background: red url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/contcatus/_DSC0315.jpg') no-repeat center;
            background-size: cover;
            width: 100%;
            height: 120vw;
        }
    }

    /* @media(max-width: 1023px) {
        .DoBetter>>>.center-box::after {
            display: none;
        }

        .DoBetter>>>.center-caption {
            bottom: 100%;
            right: 0;
            transform: translateY(100%);
        }
        .contact-box>>>.DoBetter{
            padding-bottom: 800px;
        }
    }

    @media(max-width: 403px) {
        .contact-box>>>.DoBetter {
            padding-bottom: 1000px;
        }
    } */
</style>


// WEBPACK FOOTER //
// src/pages/main/contact.vue